export const configLED = {
  type: "bar",
  plugins: {
    title: {
      display: true,
      text: "Évolution de la LED (sur les 6 derniers mois)",
      font: { size: 14 },
      padding: 20,
    },
    legend: {
      position: "bottom",
      labels: { font: { size: 14 } },
    },
    datalabels: {
      align: "top",
      anchor: "end",
      offset: -35,
      backgroundColor: "#3D3D3D",
      borderRadius: 4,
      color: "white",
      font: {
        weight: "bold",
      },
      padding: 6,
    },
  },
  responsive: true,
  scales: {
    y: {
      beginAtZero: true,
      suggestedMax: 1200,
    },
  },
};

export const dataConfigLED = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "LED (en mg)",
      data: data.led,
      backgroundColor: "#2196F3",
      datalabels: { display: true },
      borderRadius: {
        topLeft: 6,
        topRight: 6,
        bottomLeft: 0,
        bottomRight: 0,
      },

      borderSkipped: false,
    },
  ],
});
